import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from './firebase';
import './AddProduct.css';

function AddProduct({ onClose }) {
  const [formData, setFormData] = useState({
    marca: '',
    modelo: '',
    precio: '',
    estado: 'Nuevo',
    almacenamiento: '64GB',
    color: '',
    cantidad: '',
    descripcion: ''
  });
  const [imagenes, setImagenes] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImagenes(files);

    // Crear previews
    const newPreviews = files.map(file => URL.createObjectURL(file));
    setPreviews(newPreviews);
  };

  const removeImage = (index) => {
    const newImagenes = imagenes.filter((_, i) => i !== index);
    const newPreviews = previews.filter((_, i) => i !== index);
    setImagenes(newImagenes);
    setPreviews(newPreviews);
  };

  const uploadImages = async () => {
    const urls = [];
    for (let i = 0; i < imagenes.length; i++) {
      const imagen = imagenes[i];
      const fileName = `productos/${Date.now()}_${i}.jpg`;
      const imageRef = ref(storage, fileName);
      
      await uploadBytes(imageRef, imagen);
      const url = await getDownloadURL(imageRef);
      urls.push(url);
    }
    return urls;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validaciones
    if (!formData.marca || !formData.modelo || !formData.precio || !formData.color || !formData.cantidad) {
      setError('Por favor completa todos los campos obligatorios');
      return;
    }

    if (imagenes.length === 0) {
      setError('Por favor agrega al menos una imagen');
      return;
    }

    setLoading(true);

    try {
      // Subir imágenes
      const imageURLs = await uploadImages();

      // Crear producto
      await addDoc(collection(db, 'productos'), {
        marca: formData.marca,
        modelo: formData.modelo,
        precio: parseFloat(formData.precio),
        estado: formData.estado,
        almacenamiento: formData.almacenamiento,
        color: formData.color,
        cantidad: parseInt(formData.cantidad),
        descripcion: formData.descripcion,
        imageURLs,
        disponible: true,
        createdAt: new Date(),
        updatedAt: new Date()
      });

      alert('✅ Producto agregado exitosamente');
      onClose();
    } catch (err) {
      console.error('Error:', err);
      setError('Error al agregar producto: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-product-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>➕ Agregar Producto</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>📸 Imágenes del Producto</h3>
            
            <div className="image-upload-area">
              {previews.length === 0 ? (
                <label className="upload-label">
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    style={{ display: 'none' }}
                  />
                  <div className="upload-placeholder">
                    <span style={{ fontSize: '50px' }}>📷</span>
                    <p>Toca para agregar imágenes</p>
                  </div>
                </label>
              ) : (
                <div className="image-previews">
                  {previews.map((preview, index) => (
                    <div key={index} className="preview-item">
                      <img src={preview} alt={`Preview ${index + 1}`} />
                      <button
                        type="button"
                        className="remove-image"
                        onClick={() => removeImage(index)}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                  <label className="add-more">
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageChange}
                      style={{ display: 'none' }}
                    />
                    <span>➕</span>
                  </label>
                </div>
              )}
            </div>
          </div>

          <div className="form-section">
            <h3>📱 Información del Producto</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Marca *</label>
                <input
                  type="text"
                  name="marca"
                  value={formData.marca}
                  onChange={handleInputChange}
                  placeholder="Ej: Apple, Samsung"
                  required
                />
              </div>

              <div className="form-group">
                <label>Modelo *</label>
                <input
                  type="text"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleInputChange}
                  placeholder="Ej: iPhone 14 Pro"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Precio (HNL) *</label>
                <input
                  type="number"
                  name="precio"
                  value={formData.precio}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                  required
                />
              </div>

              <div className="form-group">
                <label>Cantidad *</label>
                <input
                  type="number"
                  name="cantidad"
                  value={formData.cantidad}
                  onChange={handleInputChange}
                  placeholder="0"
                  min="0"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Estado</label>
                <select name="estado" value={formData.estado} onChange={handleInputChange}>
                  <option value="Nuevo">Nuevo</option>
                  <option value="Seminuevo">Seminuevo</option>
                  <option value="Usado">Usado</option>
                  <option value="Refurbished">Refurbished</option>
                </select>
              </div>

              <div className="form-group">
                <label>Almacenamiento</label>
                <select name="almacenamiento" value={formData.almacenamiento} onChange={handleInputChange}>
                  <option value="32GB">32GB</option>
                  <option value="64GB">64GB</option>
                  <option value="128GB">128GB</option>
                  <option value="256GB">256GB</option>
                  <option value="512GB">512GB</option>
                  <option value="1TB">1TB</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Color *</label>
              <input
                type="text"
                name="color"
                value={formData.color}
                onChange={handleInputChange}
                placeholder="Ej: Negro, Blanco, Azul"
                required
              />
            </div>

            <div className="form-group">
              <label>Descripción</label>
              <textarea
                name="descripcion"
                value={formData.descripcion}
                onChange={handleInputChange}
                placeholder="Descripción detallada del producto..."
                rows="4"
              />
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Guardando...' : '✅ Agregar Producto'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddProduct;